import styled from "styled-components";

export const ServicesStyle = styled.main``;


